import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CourseEditor } from "@/features/courses/components/authoring/course-editor";

function AuthoringCoursePage() {
  const params = useParams({ from: "/_app/authoring/$courseId" });
  return <CourseEditor courseId={params().courseId} />;
}

export const authoringCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/authoring/$courseId",
  component: AuthoringCoursePage,
});
